import React from "react";
import { Field } from "react-final-form";
import CheckBox from "../CheckBox";

interface IOutlinedCheckBox {
  validate?: (value: any) => any;
  name: string;
  onKeyPress?: (
    event: React.KeyboardEvent<HTMLInputElement> & { target: HTMLInputElement }
  ) => void;
  disabled?: boolean;
  label?: string;
  slotProps?: { typography?: { [key: string]: any } };
}

const OutlinedCheckBox = React.forwardRef<any, IOutlinedCheckBox>(
  (props, ref) => {
    const { disabled, label, onKeyPress, slotProps, ...rest } = props;

    return (
      <Field
        type="checkbox"
        render={({
          input,
          meta,
          ...restTextField
        }: {
          [name: string]: any;
        }) => {
          return (
            <CheckBox
              {...restTextField}
              {...input}
              disabled={meta.submitting || disabled}
              label={label}
              ref={ref}
              onKeyPress={onKeyPress}
              slotProps={slotProps}
            />
          );
        }}
        {...rest}
      />
    );
  }
);

export default React.memo(OutlinedCheckBox);
